import { QuoteStatus, RequestForQuoteStatus } from '~/graphql/graphql';

const CLOSED_STATUSES: ReadonlySet<RequestForQuoteStatus> = new Set([
  RequestForQuoteStatus.Fulfilled,
  RequestForQuoteStatus.Archived,
]);

export function isClosedRequestForQuoteStatus(
  status: RequestForQuoteStatus
): boolean {
  return CLOSED_STATUSES.has(status);
}

export function countOpenRequestsForQuote(
  requestsForQuote: readonly { status: RequestForQuoteStatus }[]
): number {
  return requestsForQuote.filter(
    ({ status }) => !isClosedRequestForQuoteStatus(status)
  ).length;
}

export function partitionArchivedQuotes<TQuote extends { status: QuoteStatus }>(
  quotes: readonly TQuote[]
): { activeQuotes: TQuote[]; archivedQuotes: TQuote[] } {
  return {
    activeQuotes: quotes.filter(
      ({ status }) => status !== QuoteStatus.Archived
    ),
    archivedQuotes: quotes.filter(
      ({ status }) => status === QuoteStatus.Archived
    ),
  };
}
